import { DialogContent, List, ListItem, styled } from '@mui/material'
import { Body2, TextField } from '@collaborate-health/uikit'

export const StyledDialogContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  maxHeight: '50vh',
})

export const DateText = styled(Body2)(({ theme }) => ({
  marginTop: theme.spacing(2),
}))

export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}))

export const StyledList = styled(List)({
  overflowY: 'auto',
  flex: 1,
})

export const SelectAllListItem = styled(ListItem)({
  cursor: 'pointer',
})

export const TruncatedText = styled(Body2)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

